import ApiRequestBuilder from '../ApiService/Request/ApiRequestBuilder';


const API_PATH_VALIDATE_BASE = '/validate';

const API_PATH_VALIDATE_PHONE = `${API_PATH_VALIDATE_BASE}/phone`;


class ValidationService {

    /**
     * @type {ApiService}
     */
    apiService;


    /**
     * @param apiService {ApiService}
     */
    constructor(apiService) {

        this.apiService = apiService;
    }


    /**
     * @param phone {object} Phone object
     * @return {Promise<Boolean>} True if given phone is valid; false if not
     */
    async validatePhone(phone) {

        const validationRequest = ApiRequestBuilder.post(API_PATH_VALIDATE_PHONE)
            .json()
            .body({phone})
            .build();

        const response = await this.apiService.execute(validationRequest);

        return response.isSuccessful();
    }
}


export default ValidationService;
